import { useState, useEffect } from "react";
import { getFeatureToggle, getLocale, history } from "../../../common/helpers";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { UserCircleIcon } from "../../../common/icons/InlineIcons";
import { TabModalWrapper } from "./style";
import { assetsHomeServices } from "../../../assets/home/services";
import { useTranslation } from "react-i18next";
import { useComponentVisible } from "../utils";

const TabModal = () => {
  const { t } = useTranslation();
  const language = getLocale(history.location.pathname, true);
  const { user, loggedIn } = useSelector((state) => state.login);
  const currentUser =
    (Array.isArray(user?.user) && user.user[0]) ||
    (user?.user && !Array.isArray(user.user) ? user.user : null) ||
    (Array.isArray(user) && user[0]) ||
    (user && user.userAccountId ? user : null) ||
    {};
  const firstName = currentUser?.firstName ?? "";
  const organizationId = currentUser?.organizationId ?? null;
  const [assetId, setAssetId] = useState(null);

  useEffect(() => {
    async function fetchAssetID() {
      if (!loggedIn || !organizationId) {
        return;
      }
      const containerId = await assetsHomeServices
        .getOrgContainers(organizationId)
        .then((r) => r.containerlist[0].containerId)
        .catch(() => console.warn("please try again"));
      setAssetId(containerId);
    }
    fetchAssetID();
  }, [loggedIn, organizationId]);

  const { ref, isComponentVisible } = useComponentVisible(true);
  const siteMinderToggle = getFeatureToggle("SiteMinder MVP")[0]?.isVisible;
  const sopAccess = useSelector((state) => state.login.sopAccessAuthorized ?? false);

  return (
    <TabModalWrapper>
      <div ref={ref}>
        {isComponentVisible && (
          <div className="tab-modal-container">
            <li className="side-nav1">
              <div className="user-logo-dropdown">
                <UserCircleIcon />
              </div>
              <div className="user_name_span">{firstName}</div>
            </li>

            <div className="tab-items">
              <NavLink
                to={language + "/fc/dashboard"}
                onClick={() => {
                  history.push(language + "/fc/dashboard");
                }}
                className="side-nav1"
              >
                {t("DASHBOARD")}
              </NavLink>

              <NavLink
                to={language + "/measurements"}
                onClick={() => {
                  history.push(language + "/measurements");
                }}
                className="side-nav1"
              >
                {t("Measurements")}
              </NavLink>

              <NavLink
                to={`${language}/asset-dashboard/${assetId}`}
                onClick={() => {
                  history.push(`${language}/asset-dashboard/${assetId}`);
                }}
                className="side-nav1"
              >
                {t("Assets")}
              </NavLink>

              <NavLink
                to={language + "/work-orders/list"}
                onClick={() => {
                  history.push(language + "/work-orders/list");
                }}
                className="side-nav1"
              >
                {t("Work Orders")}
              </NavLink>

              <NavLink
                to={language + "/team"}
                onClick={() => {
                  history.push(language + "/team");
                }}
                className="side-nav1"
              >
                {t("team")}
              </NavLink>

              <NavLink
                to={language + "/exports/list"}
                onClick={() => {
                  history.push(language + "/exports/list");
                }}
                className="side-nav1"
              >
                {t("exports")}
              </NavLink>

              <NavLink
                to={language + "/reports/list"}
                onClick={() => {
                  history.push(language + "/reports/list");
                }}
                className="side-nav1"
              >
                {t("Reports")}
              </NavLink>

              {siteMinderToggle && sopAccess && (
                <NavLink
                  exact
                  to={language + "/sop"}
                  className="side-nav1"
                  activeClassName="active"
                  onClick={() => {
                    history.push(language + "/sop");
                  }}
                >
                  SOP<span style={{ textTransform: "lowercase" }}>s</span>
                </NavLink>
              )}
            </div>
          </div>
        )}
      </div>
    </TabModalWrapper>
  );
};

export default TabModal;
